import { inject, InjectionToken, Provider } from '@angular/core';

/**
 * Marks descendant `pdf-preview` instances as exclusive owners of the
 * ngx-extended-pdf-viewer singleton (e.g. the content-preview overlay).
 */
export const PDF_PREVIEW_EXCLUSIVE = new InjectionToken<boolean>('PDF_PREVIEW_EXCLUSIVE');

export const provideExclusivePdfPreview = (): Provider => ({
	provide: PDF_PREVIEW_EXCLUSIVE,
	useValue: true,
});

export const injectExclusivePdfPreview = (): boolean => {
	return inject(PDF_PREVIEW_EXCLUSIVE, { optional: true }) === true;
};
